import { useMutation } from "@apollo/client";
import { Toast } from "@aurem/ui";
import { useI18n } from "providers/I18nProvider";
import { log } from "utils/employee";

/**
 * Returns a mutate function that catches errors and opens Error Toast Notifications instead
 */
export const useSafeMutation: typeof useMutation = (mutation, options) => {
  const { t } = useI18n();
  const [mutate, result] = useMutation(mutation, options);
  const safeMutate: typeof mutate = (options) => {
    return mutate(options).catch((err) => {
      const gqlError = err?.graphQLErrors?.[0];
      const message =
        gqlError?.message || (err instanceof Error ? err.message : "");

      const code =
        gqlError?.extensions?.code ||
        gqlError?.extensions?.exception?.code ||
        gqlError?.extensions?.exception?.cause?.message ||
        undefined;

      if (
        code?.includes("accounts.mfa.") ||
        code?.includes("accounts.email_otp.")
      ) {
        return Promise.reject(new Error(message));
      }

      if (err instanceof Error) {
        Toast.error({
          title: err.message,
        });
      } else {
        log.err(err);
        Toast.error({
          title: t("apps.employee.common.unexpectedError.title"),
          text: t("apps.employee.common.unexpectedError.description"),
        });
      }
      return { errors: [err] };
    });
  };
  return [safeMutate, result];
};
